import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    isLogin: 1,        //0已登录    1未登录
    role: '',
    userId:'',
    icon: '',
    authentation: '',
    chapterId:'',
    taskId:'',
    isJoined:false,
    token:'',
    loginTime:'',
    Logo:'',
    msgStatus:true,//消息状态
  },
  mutations: {
    toggleIsLogin(state, payload) {
      state.isLogin = payload.isLogin
      state.role = payload.role
      state.userId=payload.userId
      state.username = payload.username
      state.icon = payload.icon
      state.authentation = payload.authentation
      state.username = payload.username
    },
    changeIcon(state,payload){
      state.icon=payload.icon
    },
    changeLogo(state,payload){
      state.Logo=payload.Logo
    },
    clear(state){
      state.isLogin = 1
      state.role = ''
      state.userId=''
      state.username = ''
      state.icon = ''
      state.authentation = ''
    },
    getIds(state,payload){
      state.chapterId=payload.chapterId
      state.taskId=payload.taskId
    },
    changeCourseStatus(state,payload){
      state.isJoined=payload.isJoined
    },
    changeMessageStatus(state,payload){
      state.msgStatus=payload.status
    }
  }
})